<template>
  <form
    action="/landing/api/prg-link"
    method="post"
    rel="noindex nofollow"
    class="d-inline-block"
    target="_blank"
  >
    <client-only>
      <input
        type="hidden"
        :name="headerName"
        :value="csrf"
      />
    </client-only>
    <input
      type="hidden"
      name="url"
      :value="url"
    />
    <button
      type="submit"
      :class="textClass"
    >
      {{ text }}
    </button>
  </form>
</template>

<script setup lang="ts">
type Props = {
  text: string
  url: string
  textClass?: string
}

withDefaults(defineProps<Props>(), {
  textClass: '',
})

const { csrf, headerName } = useCsrf()
</script>
